/**
 * ケース変換ユーティリティ
 * APIレスポンスのsnake_caseをcamelCaseに変換、またはその逆の変換を行う
 */

/**
 * snake_caseをcamelCaseに変換
 */
export const snakeToCamel = (str: string): string => {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

/**
 * camelCaseをsnake_caseに変換
 */
export const camelToSnake = (str: string): string => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

/**
 * オブジェクトのキーをsnake_caseからcamelCaseに再帰的に変換
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toCamelCase = <T = any>(obj: any): T => {
  if (obj === null || obj === undefined) {
    return obj
  }

  if (obj instanceof Date) {
    return obj as T
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => toCamelCase(item)) as T
  }

  if (typeof obj === 'object') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const converted: any = {}
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const camelKey = snakeToCamel(key)
        converted[camelKey] = toCamelCase(obj[key])
      }
    }
    return converted
  }

  return obj
}

/**
 * オブジェクトのキーをcamelCaseからsnake_caseに再帰的に変換
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toSnakeCase = <T = any>(obj: any): T => {
  if (obj === null || obj === undefined) {
    return obj
  }

  if (obj instanceof Date) {
    return obj as T
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => toSnakeCase(item)) as T
  }

  if (typeof obj === 'object') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const converted: any = {}
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const snakeKey = camelToSnake(key)
        converted[snakeKey] = toSnakeCase(obj[key])
      }
    }
    return converted
  }

  return obj
}

// エイリアス
export const camelCase = toCamelCase
export const snakeCase = toSnakeCase
